import { Outlet } from "react-router";

const Tokens = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Tokens;
